module.exports = __webpack_public_path__ + "static/media/img-685a51cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/pw-logo.png
// module id = 5299
// module chunks = 39